import { Box, Divider, Grid, Skeleton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatDateTime } from "../../../../../helpers/methods";
import rahuTransitsStyles from "../RahuTransits.styles";

interface CustomProps {
  meanPada: any;
  truePada: any;
  isLoading: boolean;
}

const Pada = (props: CustomProps) => {
  const classes = rahuTransitsStyles;
  const { t, i18n } = useTranslation();

  const getMeanRahu = () => {
    return (
      <Stack direction={"column"} alignItems={"center"} spacing={2}>
        {props.meanPada.map((item: any) => {
          return (
            <Box sx={classes.transitBox}>
              {props.isLoading ? (
                <>
                  <Skeleton
                    variant="text"
                    width="80%"
                    height={30}
                    sx={{ m: 1 }}
                  />
                  <Skeleton
                    variant="text"
                    width="60%"
                    height={30}
                    sx={{ m: 1 }}
                  />
                </>
              ) : (
                <>
                  <Typography my={1} mx={1} sx={classes.contentText}>
                    From <b>{item.from_pada}</b> to <b>{item.to_pada}</b>{" "}
                  </Typography>
                  <Typography mb={1} mx={1} sx={classes.contentText}>
                    {formatDateTime(item.datetime, i18n.language)}
                  </Typography>
                </>
              )}
            </Box>
          );
        })}
      </Stack>
    );
  };

  const getTrueRahu = () => {
    return (
      <Stack direction={"column"} alignItems={"center"} spacing={2}>
        {props.truePada.map((item: any) => {
          return (
            <Box sx={classes.transitBox}>
              {props.isLoading ? (
                <>
                  <Skeleton
                    variant="text"
                    width="80%"
                    height={30}
                    sx={{ m: 1 }}
                  />
                  <Skeleton
                    variant="text"
                    width="60%"
                    height={30}
                    sx={{ m: 1 }}
                  />
                </>
              ) : (
                <>
                  <Typography my={1} mx={1} sx={classes.contentText}>
                    From <b>{item.from_pada}</b> to <b>{item.to_pada}</b>{" "}
                  </Typography>
                  <Typography mb={1} mx={1} sx={classes.contentText}>
                    {formatDateTime(item.datetime, i18n.language)}
                  </Typography>
                </>
              )}
            </Box>
          );
        })}
      </Stack>
    );
  };

  const getPada = () => {
    return (
      <Grid container>
        <Grid item xl={6} lg={6} md={12} sm={12} xs={12} p={1}>
          <Stack direction={"column"} alignItems={"center"} spacing={2} pb={1}>
            <Typography sx={classes.transitHeader} px={2}>
              {t("rahuTransit")}
            </Typography>
            <Divider
              sx={{
                border: "1px solid rgba(255, 255, 255, 0.21)",
                width: "50%",
                height: "0px",
                mt: "2px !important",
                mb: "8px !important",
              }}
            />
          </Stack>
          {getMeanRahu()}
        </Grid>
        <Grid item xl={6} lg={6} md={12} sm={12} xs={12} p={1}>
          <Stack direction={"column"} alignItems={"center"} spacing={2} pb={1}>
            <Typography sx={classes.transitHeader} px={2}>
              {t("trueRahuTransit")}
            </Typography>
            <Divider
              sx={{
                border: "1px solid rgba(255, 255, 255, 0.21)",
                width: "50%",
                height: "0px",
                mt: "2px !important",
                mb: "8px !important",
              }}
            />
          </Stack>
          {getTrueRahu()}
        </Grid>
      </Grid>
    );
  };

  return getPada();
};

export default Pada;
